import React, { useEffect, useState } from "react";
import MainPagetitle from "../../../layouts/MainPagetitle";
import RepaymentModal from "../LoanDetails/Repayments/RepaymentModal";

const UserDetails = (props) => {
  var BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;
  // ----------------------------------------------------------------
  const [search, setSearch] = useState({
    // page: 1,
    // limit: 10,
  });
  const [userdata, setUserdata] = useState(null);
  const getCustomer = () => {
    let payload = {
      customerId: props.urlparams.params.customerId,
    };
    props.apis.apiGetCustomerOverallInfo(payload).then((response) => {
      console.log({ response });
      setUserdata(response);
    });
  };
  useEffect(() => {
    getCustomer();
  }, []);

  const handleDelete = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    console.log({ value });
    let properties = {
      title: `Are you sure you want to delete this user's ${value?.toTitleCase()} details?`,
      icon: "info",
      iconColor: "#BB1766",
      showCancelButton: true,
      confirmButtonColor: "#BB1766",
      cancelButtonColor: "##D6DBE7",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    };
    let successProperties = {
      title: `${value?.toTitleCase()} details deleted successfully !!`,
      icon: "success",
      iconColor: "#BB1766",
      timer: 4000,
    };
    swal2.fire(properties).then((result) => {
      if (result.isConfirmed) {
        const resolve = () => {
          swal2.fire(successProperties);
          getSingleProfileInfo();
        };
        // if (value === "aadhar") {
        //   props.apis
        //     .apiDeleteAadhar({ profileId: empdata?.profileId })
        //     .then(() => resolve());
        // }
        // if (value === "pan") {
        //   props.apis
        //     .apiDeletePan({ profileId: empdata?.profileId })
        //     .then(() => resolve());
        // }
      }
    });
  };
  // ----------------------------------------------------------------
  const [editData, setEditData] = useState([]);
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });
  const [defaultCompanies, setDefaultCompanies] = useState([]);

  const [modalFields, setModalFields] = useState([
    {
      name: "companyname",
      label: "Company Name",
      type: "select",
      options: [],
      searchFn: (value) => handleCompanyNameSearch(value),
      onChange: (...args) => handleCompanyChange(...args),
      placeholder: "Please enter",
      required: true,
    },
    {
      name: "newcompanyname",
      label: "New Company Name",
      type: "text",
      placeholder: "Please enter",
      disabled: true,
    },
    {
      name: "monthlySalary",
      label: "Monthly Salary",
      type: "text",
      placeholder: "Please enter",
    },
    {
      name: "salaryMode",
      label: "Mode of Salary",
      type: "select",
      options: _enum.MODE_OF_SALARY,
      placeholder: "Please enter",
    },
    {
      name: "officialEmail",
      label: "Office Email",
      type: "email",
      placeholder: "Please enter",
      required: true,
    },
  ]);

  const handleCompanyNameSearch = (params) => {
    // console.log(params);
    let value = params?.state?.search;
    let payload = {
      companyName: value,
    };
    if (value.length >= 3) {
      mixins.debounce(() => {
        props.apis.apiGetMasterCompanies(payload).then(({ data }) => {
          if (data) {
            let companyNameInput = document.querySelector(
              "[name='appinput-companyname'].form-group"
            );
            let companySelect = companyNameInput.vnode.refs.select;
            let { searchResults } = companySelect.state;
            let datawithkey = data?.options("companyName");
            // console.log({ searchResults, datawithkey });
            searchResults = datawithkey;

            if (searchResults.length === 0) {
              companySelect.setState({
                searchResults: [{ key: "OTHERS", label: "Others" }],
              });
            } else {
              companySelect.setState({ searchResults });
            }
          }
        });
      }, 1000);
    }
  };

  const handleCompanyChange = (value) => {
    let key = value[0]?.key;

    var newCompanyNameInput = document.querySelector("[name='newcompanyname']");
    if (key === "OTHERS") {
      newCompanyNameInput.disabled = false;
    } else {
      newCompanyNameInput.disabled = true;
      newCompanyNameInput.value = "";
      newCompanyNameInput.defaultValue = "";
    }
  };

  const getCompanies = () => {
    let payload = {
      ...search,
    };
    props.apis.apiGetMasterCompanies(payload).then(({ data }) => {
      // console.log({ data });
      if (data) {
        setDefaultCompanies(data);
        let companyNameField = modalFields.find(
          (field) => field.name === "companyname"
        );
        companyNameField.options = data.options("companyName");
        setModalFields([...modalFields]);
      }
    });
  };

  const openModal = () => {
    setOpenCanvas(true);
  };

  const closeModal = () => {
    setOpenCanvas(false);
  };

  const onModalClose = () => {
    console.log("onModalClose");
    closeModal();
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
    setErrorMessage({ name: "", message: "" });
  };

  const editIncomeDetails = (e) => {
    setEditmode(true);
    setViewmode(false);

    let editdata = {
      companyname: userdata?.companyname,
      newcompanyname: "",
      salaryMode: userdata?.salaryMode,
      monthlySalary: userdata?.monthlySalary,
      officialEmail: userdata?.officialEmail,
    };

    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    console.log({ fields, editdata });
    setEditData(editdata);
    setPopupfields(fields);
    setPopupdata(editdata);
    setOpenCanvas(true);
  };

  const updateFields = (fields, data) => {
    let result = fields?.map((field) => {
      let filteredData = Object.only(
        data,
        fields.map((v) => v.name)
      );

      if (field.name === "companyname") {
        // console.log(field, data[field?.name]);
        var companyNameInput = document.querySelector(
          "[name='appinput-companyname'].form-group"
        );
        var newCompanyNameInput = document.querySelector(
          "[name='newcompanyname']"
        );
        // console.log(companyNameInput, newCompanyNameInput);

        if (companyNameInput) {
          var companySelect = companyNameInput?.vnode.refs.select;
          // console.log({ companySelect });

          if (companySelect && companySelect?.state?.values?.length === 0) {
            let value = filteredData[field.name];
            let payload = {
              companyName: value,
            };
            if (value?.length >= 3) {
              props.apis.apiGetMasterCompanies(payload).then(({ data }) => {
                if (data) {
                  // console.log({ "search data": data });
                  if (companySelect) {
                    companySelect = companyNameInput.vnode.refs.select;
                    let { searchResults } = companySelect?.state || {};
                    let datawithkey = data?.options("companyName");
                    // console.log({ searchResults, datawithkey });

                    if (data.length === 0) {
                      companySelect?.setState(
                        {
                          searchResults: [{ key: "OTHERS", label: "Others" }],
                          values: [{ key: "OTHERS", label: "Others" }],
                        },
                        () => {
                          companySelect?.setState({
                            searchResults,
                            values: [{ key: "OTHERS", label: "Others" }],
                          });
                        }
                      );
                      newCompanyNameInput.value = value;
                    } else {
                      companySelect?.setState({
                        searchResults,
                        values: [
                          {
                            key: datawithkey[0].key,
                            label: datawithkey[0].label,
                          },
                        ],
                      });
                    }
                  }
                }
              });
            }
          }
        }
      }
      return {
        ...field,
        defaultValue: data[field?.name],
        // disabled: true,
      };
    });
    // console.log(result);
    return result;
  };

  const handleSubmit = (e, data, form) => {
    e.preventDefault();
    let payload = {
      ...Object.except(data, "newcompanyname"),
    };
    if (data?.companyname === "OTHERS") {
      payload.companyname = data.newcompanyname;
    } else {
      payload.companyname = data.companyname;
    }
    console.log({ data, payload });

    props.apis
      .apiAdminUpdateCustomerDetails(payload, {
        customerId: userdata?.customerId,
      })
      .then((res) => {
        swal2.fire({
          title: "Income Details updated successfully.",
          icon: "success",
          iconColor: "#BB1766",
          timer: 4000,
        });
        closeModal();
        getCustomer();
      })
      .catch((error) => console.log(error));
  };

  // ----------------------------------------------------------------
  const [editUserDetailsData, setEditUserDetailsData] = useState([]);
  const [editUserDetailmode, setEditUserDetailmode] = useState(false);
  const [viewUserDetailmode, setViewUserDetailmode] = useState(false);
  const [openUserDetailCanvas, setOpenUserDetailCanvas] = useState(false);
  const [userDetailPopupfields, setUserDetailPopupfields] = useState({});
  const [userDetailPopupdata, setUserDetailPopupdata] = useState({});
  const userDetailFields = [
    {
      label: "Date of Birth",
      name: "dob",
      type: "date",
    }
  ];

  const openUserDetailModal = () => {
    setOpenUserDetailCanvas(true);
  };

  const closeUserDetailModal = () => {
    setOpenUserDetailCanvas(false);
  };

  const editUserDetails = (record) => {
    console.log({ record });
    setEditUserDetailmode(true);
    setViewUserDetailmode(false);    
    let filteredData = Object.only(
        record,
        userDetailFields.map((v) => v.name)
    );
        console.log({ filteredData });
        setUserDetailPopupdata(filteredData);
        setEditUserDetailsData(record);
        let fields = (userDetailFields || []).reduce(
          (o, n) => ({ ...o, [n.name]: n }),
          {}
        );
        setUserDetailPopupfields(fields);
        openUserDetailModal()
  };

  const handleUserDetailSubmit = (e, data, form) => {
    e.preventDefault();
    let payload = {
      dob: new Date(data?.dob).toISOString()
    };
    props.apis
      .apiAdminUpdateCustomerDetails(payload, {
        customerId: userdata?.customerId,
      })
      .then((res) => {
        swal2.fire({
          title: "DOB updated successfully.",
          icon: "success",
          iconColor: "#BB1766",
          timer: 4000,
        });
        closeUserDetailModal();
        getCustomer();
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    setTimeout(() => {
      let updatedFields = updateFields(modalFields, editData);
      console.log({ updatedFields });
    }, 500);
  }, [editData]);

  useEffect(() => {
    // getCompanies();
  }, []);

  // ----------------------------------------------------------------

  props.$setNode({
    props,
    userdata,
  });
  if (userdata) {
    var {
      customerId,
      customerName,
      emailAddress,
      mobileNumber,
      dob,
      gender,
      pincode,
      dateOfJoining,
      workLocation,
      status,
      isSalaried,
      companyname,
      monthlySalary,
      salaryMode,
      officialEmail,
      netMonthlyIncome,
      natureOfBusiness,
      panFileId,
      aadharFrontFileId,
      aadharBackFileId,
      photoFileId,
      addresses,
      panCardInfo,
      aadharCardInfo,
    } = userdata;
    //

    var date_of_birth = new Date(dob).dateToDDMMYYYY(new Date(dob));
    var age = new Date(dob).getAge();
    var address, docproof, docprooflink;
    if (addresses && addresses.length > 0) {
      address =
        (addresses[0]?.address1 !== null
          ? addresses[0]?.address1?.toTitleCase()
          : "") +
        (addresses[0]?.address2 !== null
          ? `, ${addresses[0]?.address2?.toTitleCase()}`
          : "") +
        (addresses[0]?.address3 !== null
          ? `, ${addresses[0]?.address3?.toTitleCase()}.`
          : "");
    } else {
      address = "";
    }
    // ----------------------------------------------------------------
    let name = customerName;
    let firstLetter = name.charAt(0); // Get the first letter of the first word
    let secondLetterIndex = name.indexOf(" ") + 1; // Get the index of the first letter of the word after the space
    let secondLetter = name.charAt(secondLetterIndex); // Get the second letter of the word after the space
    let result = firstLetter + secondLetter; // Concatenate the first and second letters
    var initialValue = result ? result : "";
    // ----------------------------------------------------------------

    var panFileId = panFileId;
    var aadharFrontFileId = aadharFrontFileId;
    var aadharBackFileId = aadharBackFileId;
    var photoFileId = photoFileId;
    // hasAdditionalDocs
    var hasAdditionalDocs = false;
    var additionalDocs = [];
  }
  return (
    <>
      <MainPagetitle
        mainTitle="Registered User"
        back={`${customerName || "User"}`}
        backLink="/app/registeredUsers"
        pageTitle={"Registered User"}
        parentTitle={"Home"}
      />
      <div
        className={Object.className({
          "container-fluid": true,
        })}
      >
        <div className="row g-0">
          <div className="col-xl-12">
            {/* INFO CARD */}
            <div className="info_card">
              <div className="content">
                <div className="header_section">
                  <div className="name_card">
                    <div className="avatar_circle">{initialValue || ""}</div>
                    <h2 className="name">{customerName || "-"}</h2>
                  </div>
                  <div className="user_id_badge">
                    User ID: <span>{customerId || "-"}</span>
                    <button
                      type="submit"
                      variant="outline"
                      className="btn-outline-dark edit_btn"
                      style={{top: "2px", right: "2px"}}
                      onClick={(e) => editUserDetails(userdata)}
                    >
                      <i className="fa fa-pencil"></i>
                    </button>
                  </div>
                </div>

                <div className="separator_line"></div>

                <div className="details_grid">
                  <div className="detail_item">
                    <span className="label">Gender</span>
                    <span className="value">{gender?.toTitleCase() || "-"}</span>
                  </div>
                  <div className="detail_item">
                    <span className="label">Date of Birth</span>
                    <span className="value">{date_of_birth || "-"}</span>
                  </div>
                  <div className="detail_item">
                    <span className="label">Age</span>
                    <span className="value">{age || "-"}</span>
                  </div>
                  <div className="detail_item">
                    <span className="label">Mobile No.</span>
                    <span className="value">{mobileNumber || "-"}</span>
                  </div>
                  <div className="detail_item">
                    <span className="label">Email ID</span>
                    <span className="value">{emailAddress || "-"}</span>
                  </div>
                  <div className="detail_item">
                    <span className="label">Pin Code</span>
                    <span className="value">{pincode || "-"}</span>
                  </div>

                  <div className="detail_item col_span_2">
                    <span className="label">Aadhar Address</span>
                    <span className="value whitespace-preline">{address || "-"}</span>
                  </div>
                  <div className="detail_item col_span_2">
                    <span className="label">Document Proof</span>
                    <div className="value d-flex flex-wrap">
                      <span className="whitespace-preline">{docproof || "-"}</span>
                      <span className="ms-2">
                        {docprooflink && (
                          <a
                            href={`${BASE_URL}${docprooflink}`}
                            className="download_link white"
                          >
                            Download
                          </a>
                        )}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="row mx-auto g-3">
              <div className="col-12 col-lg-4">
                {/* INCOME DETAILS */}
                <div className="modern_profile_card">
                  <div className="header_section">
                    <img
                      src={imagepaths.walletMoneyIcon}
                      alt="walletMoneyIcon"
                      className="card_icon"
                    />
                    <h2 className="title">Income Details</h2>
                  </div>
                  <div className="body_section">
                    <div className="info_row">
                      <span className="label">Company Name</span>
                      <span className="value">{companyname || "-"}</span>
                    </div>
                    <div className="info_row">
                      <span className="label">Mode of Salary</span>
                      <span className="value">{salaryMode || "-"}</span>
                    </div>
                    <div className="info_row">
                      <span className="label">Monthly Salary</span>
                      <span className="value">{monthlySalary?.cur() || "-"}</span>
                    </div>
                    <div className="info_row">
                      <span className="label">Office Email</span>
                      <span className="value">{officialEmail || "-"}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-8">
                {/* KYC CARD */}
                <div className="card redesigned_profile_card h-100">
                  <div className="card-header border-0">
                    <div className="d-flex align-items-center">
                      <img
                        src={imagepaths.userSearchIcon}
                        alt="userSearchIcon"
                        className="card_icon"
                        width="22"
                        height="22"
                      />
                      <h5 className="title ms-2 mb-0">KYC Details</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row g-0">
                      <div className="col-12 col-lg-6 pe-lg-4" style={{ borderRight: "1px solid #F0F0F0" }}>
                        <ul className="stacked_list h-100">
                          <li>
                            <span className="label">Aadhar No</span>
                            <span className="value">
                              {(aadharCardInfo &&
                                `XXXX-XXXX-${aadharCardInfo?.uid}`) ||
                                "-"}
                            </span>
                          </li>
                          <li>
                            <span className="label">PIN Code</span>
                            <span className="value">
                              {(aadharCardInfo &&
                                aadharCardInfo?.pincode) ||
                                "-"}
                            </span>
                          </li>
                          <li>
                            <span className="label">City</span>
                            <span className="value">
                              {(aadharCardInfo &&
                                aadharCardInfo?.city) ||
                                "-"}
                            </span>
                          </li>
                        </ul>
                      </div>

                      <div className="col-12 col-lg-6 ps-lg-4 mt-4 mt-lg-0">
                        <ul className="stacked_list h-100">
                          <li>
                            <span className="label">PAN No.</span>
                            <span className="value">
                              {(panCardInfo &&
                                panCardInfo?.number) ||
                                "-"}
                            </span>
                          </li>
                          <li>
                            <span className="label">Aadhar Address</span>
                            <span className="value">
                              {(aadharCardInfo &&
                                aadharCardInfo?.address) ||
                                "-"}
                            </span>
                          </li>
                          <li>
                            <span className="label">State</span>
                            <span className="value">
                              {(aadharCardInfo &&
                                aadharCardInfo?.state) ||
                                "-"}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                {/* DOCS */}
                {/* <div className="card profile_card">
                  <div className="card-header p-0 border-0">
                    <div className="d-flex align-items-center mb-3">
                      <img
                        src={imagepaths.cardGaurdIcon}
                        alt="cardGaurdIcon"
                        className="card_icon"
                      />
                      <h5 className="title ms-2 mb-0">Docs Details</h5>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div className="docs_card_container row g-0">
                      <div className="col-6 col-sm-4 col-md-6 col-lg-3">
                        <div className="docs_card">
                          <img
                            src={imagepaths.docsCardRedIcon}
                            alt="docsCardRedIcon"
                          />
                          <h2 className="title">PAN Card Front</h2>
                          {panFileId && panFileId?.length !== 0 ? (
                            <a
                              href={`${BASE_URL}${panFileId}`}
                              className="text-primary"
                            >
                              Download
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-6 col-sm-4 col-md-6 col-lg-3">
                        <div className="docs_card">
                          <img
                            src={imagepaths.docsCardRedIcon}
                            alt="docsCardRedIcon"
                          />
                          <h2 className="title">Aadhar Card (Front)</h2>
                          {aadharFrontFileId &&
                            aadharFrontFileId?.length !== 0 ? (
                            <a
                              href={`${BASE_URL}${aadharFrontFileId}`}
                              className="text-primary"
                            >
                              Download
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-6 col-sm-4 col-md-6 col-lg-3">
                        <div className="docs_card">
                          <img
                            src={imagepaths.docsCardRedIcon}
                            alt="docsCardRedIcon"
                          />
                          <h2 className="title">Aadhar Card (Back)</h2>
                          {aadharBackFileId &&
                            aadharBackFileId?.length !== 0 ? (
                            <a
                              href={`${BASE_URL}${aadharBackFileId}`}
                              className="text-primary"
                            >
                              Download
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-6 col-sm-4 col-md-6 col-lg-3">
                        <div className="docs_card">
                          <img
                            src={imagepaths.docsCardRedIcon}
                            alt="docsCardRedIcon"
                          />
                          <h2 className="title">Photo</h2>
                          {photoFileId && photoFileId?.length !== 0 ? (
                            <a
                              href={`${BASE_URL}${photoFileId}`}
                              className="text-primary"
                            >
                              Download
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}


                <div className="card redesigned_profile_card mx-0">
                  <div className="card-header border-0">
                    <div className="d-flex align-items-center">
                      <img
                        src={imagepaths.cardGaurdIcon}
                        alt="cardGaurdIcon"
                        className="card_icon"
                        width="22"
                        height="22"
                      />
                      <h5 className="title ms-2 mb-0">Docs Details</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="docs_grid">
                      <div className="doc_item">
                        <img src={imagepaths.docsCardRedIcon} alt="docsCardRedIcon" />
                        <div className="doc_info">
                          <span className="doc_title">PAN Card Front</span>
                          {panFileId ? (
                            <a
                              href={`${BASE_URL}${panFileId}`}
                              className="download_link"
                            >
                              Download
                            </a>
                          ) : (
                            <span className="download_link text-muted" style={{ textDecoration: 'none', cursor: 'default' }}>No Document</span>
                          )}
                        </div>
                      </div>

                      <div className="doc_item">
                        <img src={imagepaths.docsCardRedIcon} alt="docsCardRedIcon" />
                        <div className="doc_info">
                          <span className="doc_title">Aadhar Card (Front)</span>
                          {aadharFrontFileId ? (
                            <a
                              href={`${BASE_URL}${aadharFrontFileId}`}
                              className="download_link"
                            >
                              Download
                            </a>
                          ) : (
                            <span className="download_link text-muted" style={{ textDecoration: 'none', cursor: 'default' }}>No Document</span>
                          )}
                        </div>
                      </div>

                      <div className="doc_item">
                        <img src={imagepaths.docsCardRedIcon} alt="docsCardRedIcon" />
                        <div className="doc_info">
                          <span className="doc_title">Aadhar Card (Back)</span>
                          {aadharBackFileId ? (
                            <a
                              href={`${BASE_URL}${aadharBackFileId}`}
                              className="download_link"
                            >
                              Download
                            </a>
                          ) : (
                            <span className="download_link text-muted" style={{ textDecoration: 'none', cursor: 'default' }}>No Document</span>
                          )}
                        </div>
                      </div>

                      <div className="doc_item border-0">
                        <img src={imagepaths.docsCardRedIcon} alt="docsCardRedIcon" />
                        <div className="doc_info">
                          <span className="doc_title">Photo</span>
                          {photoFileId ? (
                            <a
                              href={`${BASE_URL}${photoFileId}`}
                              className="download_link"
                            >
                              Download
                            </a>
                          ) : (
                            <span className="download_link text-muted" style={{ textDecoration: 'none', cursor: 'default' }}>No Document</span>
                          )}
                        </div>
                      </div>

                      {hasAdditionalDocs &&
                        additionalDocs.map((doc, i) => {
                          return (
                            <div className="doc_item border-0" key={i}>
                              <img src={imagepaths.docsCardRedIcon} alt="docsCardRedIcon" />
                              <div className="doc_info">
                                <span className="doc_title">{doc?.fileName}</span>
                                {doc?.fileId ? (
                                  <a
                                    href={`${BASE_URL}${doc?.fileId}`}
                                    className="download_link"
                                  >
                                    Download
                                  </a>
                                ) : (
                                  <span className="download_link text-muted" style={{ textDecoration: 'none', cursor: 'default' }}>No Document</span>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
      <RepaymentModal
        id="employeeCanvas"
        title={`${editmode
          ? "Edit Income Details"
          : viewmode
            ? "View Income Details"
            : "Add Income Details"
          }`}
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
        editdata={editData}
        fields={popupfields}
        editmode={editmode}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? "Update" : "Submit"}`}
        disableallfields={viewmode ? true : false}
        errorMessage={errorMessage}
      />

      <RepaymentModal
        id="userDetailCanvas"
        title={`${editUserDetailmode
          ? "Edit User Details"
          : viewUserDetailmode
            ? "View User Details"
            : "Add User Details"
          }`}
        show={openUserDetailCanvas}
        onClose={() => closeUserDetailModal()}
        data={userDetailPopupdata}
        editdata={editUserDetailsData}
        fields={userDetailPopupfields}
        editmode={editUserDetailmode}
        onSubmit={(...args) => handleUserDetailSubmit(...args)}
        submitText={`${editUserDetailmode ? "Update" : "Submit"}`}
        disableallfields={viewUserDetailmode ? true : false}
        errorMessage={errorMessage}
      />
    </>
  );
};
export default constore(UserDetails);
